<div class="row">
  <div class="col-12 details">
      <div class="row inner-row" *ngFor="let item of (seCrossesDetails| keyvalue )  ;">
          <h5 class="col-6">{{item.key}}</h5>
          <div class="col-6"><span class="value d-block">{{item.value}}</span></div>
      </div>
  </div>
</div>